import {
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
} from 'react-bootstrap';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import { debounce } from '../../../Components/Common/debounce';
import Layout from '../../../Components/Layout/Layout';
import ExhibitorCard from './ExhibitorCard';
import { useGetExhibitorForPublicList } from '../apiEndpoints/exhibitorApiEndpoints';

const ExhibitorPublicPage = () => {
  const { visitorUser, dispatch } = VisitorAuthContext();
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const { data: allExhibitor, isLoading } = useGetExhibitorForPublicList({
    name,
  });

  const handleSearch = useCallback(
    debounce((value: string) => {
      setName(value);
    }, 500),
    []
  );

  return (
    <Layout pathName={'All Exhibitor'} showHeader>
      <div>
        <Container className=''>
          <div className='section-title breadcrumb-card'>
            <Row className='align-items-center'>
              <Col xs={12} md={3}>
                {' '}
                <div className='text-start flex-grow-1 w-50 fw-bold justify-content-center'>
                  Filter By
                </div>
              </Col>
              <Col xs={12} md={9}>
                <Row className='g-1 justify-content-end'>
                  <Col xs={12} md={4}>
                    <InputGroup
                      onChange={(e: any) => handleSearch(e.target.value)}
                    >
                      <Form.Control
                        placeholder='Search by company name'
                        aria-label='Username'
                        aria-describedby='basic-addon1'
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className='w-50 d-flex flex-mo-column justify-content-end'>
              <div className='filter-pasrent'></div>
            </div>
          </div>

          {isLoading ? (
            <div className='text-center'>
              <Spinner
                variant='primary'
                style={{ height: '50px', width: '50px' }}
              />
            </div>
          ) : (
            <>
              <ExhibitorCard response={allExhibitor?.data} />
            </>
          )}
        </Container>
      </div>
    </Layout>
  );
};

export default ExhibitorPublicPage;
